import Loader from 'common/modules/loader'
import { creators } from '../actions'

const invalidateLoader = ({
    payload,
    action,
    dispatch,
}) => {
    dispatch(Loader.creators.loaderIsFetching())

    dispatch(action({
        ...payload,
        loaderInvalidationEvent: creators.loaderInvalidationEvent,
    }))
}

export default invalidateLoader
